var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5AC92E97-B3B5-4255-B3CC-A856D22D2781") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Money",
    transform: "translate(-172.000000, -252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "money",
    transform: "translate(172.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,21.25 C3.3499999,21.25 1.25,19.1500001 1.25,15.5 L1.25,8.5 C1.25,4.8499999 3.3499999,2.75 7,2.75 L17,2.75 C20.6500001,2.75 22.75,4.8499999 22.75,8.5 L22.75,15.5 C22.75,19.1500001 20.6500001,21.25 17,21.25 L7,21.25 Z M2.75,8.5 L2.75,15.5 C2.75,18.3599999 4.1400001,19.75 7,19.75 L17,19.75 C19.8599999,19.75 21.25,18.3599999 21.25,15.5 L21.25,8.5 C21.25,5.6400001 19.8599999,4.25 17,4.25 L7,4.25 C4.1400001,4.25 2.75,5.6400001 2.75,8.5 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,12 C8.25,9.93000007 9.93000007,8.25 12,8.25 C14.0699999,8.25 15.75,9.93000007 15.75,12 C15.75,14.0699999 14.0699999,15.75 12,15.75 C9.93000007,15.75 8.25,14.0699999 8.25,12 Z M9.75,12 C9.75,13.24 10.76,14.25 12,14.25 C13.24,14.25 14.25,13.24 14.25,12 C14.25,10.76 13.24,9.75 12,9.75 C10.76,9.75 9.75,10.76 9.75,12 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75,14.5 L4.75,9.5 C4.75,9.09 5.09,8.75 5.5,8.75 C5.91,8.75 6.25,9.09 6.25,9.5 L6.25,14.5 C6.25,14.91 5.91,15.25 5.5,15.25 C5.09,15.25 4.75,14.91 4.75,14.5 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75,14.5 L17.75,9.5 C17.75,9.09 18.09,8.75 18.5,8.75 C18.91,8.75 19.25,9.09 19.25,9.5 L19.25,14.5 C19.25,14.91 18.91,15.25 18.5,15.25 C18.09,15.25 17.75,14.91 17.75,14.5 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMoney);
export default __webpack_public_path__ + "static/media/vuesax-outline-money.d57ac088ffe8be3ba37d54ea92f52474.svg";
export { ForwardRef as ReactComponent };